module.exports = __webpack_public_path__ + "ea317dd63168c8d4814c0cc5ead56269.svg";